import { runAsPublic } from "../../../helpers/api-helper";
import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
import SellerAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/SellerAppResource";
import {useAuthStore}  from '@store';
import { cloneDeep } from "lodash";
const include = [
    'property',
    'property.state',
    'sellers',
    'sellers.user',
    'disclosure',
    'disclosure.jotFormDisclosureSessions',
    'disclosure.jotFormDisclosureSessions.files',
    'disclosure.jotFormDisclosureSessions.form',
    'disclosure.jotFormDisclosureSessions.form.parentForm',
    'disclosure.jotFormDisclosureSessions.form.sections',
    'homeSaleLegalProtection',
    'escrowOfficer',
    'agent',
    'agent.avatarFile',
    'agent.companyLogoFile',
    'agent.licenses',
    'invitation',
    'forms',
    'forms.sections',
    'forms.parentForm',
    'broker'
];
const actions = {
    async setSelectedOrderDetailsByUuid(chosenUuid) {
        let ret = null;
        ret = this._allAssociatedOrders.find(f=>f.uuid === chosenUuid);
        this._selectedOrderDetails = ret;
    },
    async setSelectedOrderDetailsByDeveloperListingId(dlid) {
        let ret = null;
        ret = this._allAssociatedOrders.find(f=>f.developerListingId === dlid);
        this._selectedOrderDetails = ret;  
    },
    async fetchOrderUsingUuid(uuid) {
        let o = null;

        o = new OrderAppResource({
            uuid: uuid,
        });

        await o.find(include);
        if (o && !!o._uuid) {
            const idx = this._allAssociatedOrders.findIndex(f=>f.uuid === o.uuid);
            if (idx === -1) {
                this._allAssociatedOrders = [
                    ...this._allAssociatedOrders,
                    o
                ]
            } else {
                this._allAssociatedOrders[idx] = o;
                this._allAssociatedOrders = [
                    ...this._allAssociatedOrders
                ];
            }
        }
    },
    async fetchOrderUsingDeveloperListingId(developerListingId) {
        let o = null;
        
        const authStore = useAuthStore();
        const appResourceSearch = new AppResourceSearch('order');

        await appResourceSearch.setSearchData({
            pageSize: 1,
            filter: new ApiFilter({
                params: {
                    agentUuid: authStore.me.uuid,
                    referringPlatformListingId: developerListingId,
                },
            }),
            include: include
        }, false);

        await appResourceSearch.search();

        if (!appResourceSearch.appResourceCollection?.isEmpty) {
            o = appResourceSearch.appResourceCollection.getFirst();
            const idx = this._allAssociatedOrders.findIndex(f=>f.uuid === o.uuid);
            if (idx === -1) {
                this._allAssociatedOrders = [
                    ...this._allAssociatedOrders,
                    o
                ]
            } else {
                this._allAssociatedOrders[idx] = o;
                this._allAssociatedOrders = [
                    ...this._allAssociatedOrders
                ];
            }
        }

    },
    async fetchOrdersForAgentUuid() {
        let oars = new AppResourceSearch('order');
        const authStore = useAuthStore();
        const sd = {
            pageSize: 100,
            filter: new ApiFilter({
                params: {
                    agentUuid: authStore.me.uuid,
                },
            }),
            include: include
        };

        await oars.setSearchData(sd);
        await oars.search();

        if (!oars.appResourceCollection?.isEmpty) {
            oars.appResourceCollection.toArray().map(o => {
                const idx = this._allAssociatedOrders.findIndex(f=>f.uuid === o.uuid);
                if (idx === -1) {
                    this._allAssociatedOrders = [
                        ...this._allAssociatedOrders,
                        o
                    ]
                } else {
                    this._allAssociatedOrders[idx] = o;
                    this._allAssociatedOrders = [
                        ...this._allAssociatedOrders
                    ];
                }
            })
        }
    },
    async fetchMyOrdersAsSeller() {
        const authStore = useAuthStore();
        const searchData = {
            pagination: 'disabled',
            filter: new ApiFilter({
                relations: {
                    andOr: "and",
                    sellers: new ApiFilter({
                        andOr: "and",
                        params: {
                            userUuid: authStore.me.uuid,
                        },
                    }),
                },
            }),
            include: include
        };
        let oars;
        
        oars = new AppResourceSearch('order');
        await oars.setSearchData(searchData);
        await oars.search();

        if (!oars.appResourceCollection?.isEmpty) {
            oars.appResourceCollection.toArray().map(o => {
                const idx = this._allAssociatedOrders.findIndex(f=>f.uuid === o.uuid);
                if (idx === -1) {
                    this._allAssociatedOrders = [
                        ...this._allAssociatedOrders,
                        o
                    ]
                } else {
                    this._allAssociatedOrders[idx] = o;
                    this._allAssociatedOrders = [
                        ...this._allAssociatedOrders
                    ];
                    
                }
            })
        }
    },
};

export default actions;
